module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-checkbox-group"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-3189a2df!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/checkbox/src/checkbox-group.vue
// module id = 635
// module chunks = 0